import {
  AiActivityLogsFiltersDto,
  AiDelayedDeliveriesFiltersDto,
  getAiActivityLogs,
  getAiDelayedDeliveries as getLegacyAiDelayedDeliveries,
} from '@/shared/api/ai-audit';
import {
  AiDelayedDeliveryFiltersDto,
  AiTraceFiltersDto,
  getAiDelayedDeliveries,
  getAiTraces,
} from '@/shared/api/ai-trace';
import { useAppQuery } from '@/shared/lib/useAppQuery';

export function useAiActivityLogs(filters: AiActivityLogsFiltersDto = {}) {
  return useAppQuery({
    queryKey: ['ai-activity-logs', filters],
    queryFn: () => getAiActivityLogs(filters),
    customError: true,
  });
}

export function useAiDelayedDeliveries(
  filters: AiDelayedDeliveriesFiltersDto = {}
) {
  return useAppQuery({
    queryKey: ['ai-delayed-deliveries', filters],
    queryFn: () => getLegacyAiDelayedDeliveries(filters),
    customError: true,
  });
}

export function useAiTracePreview(filters: AiTraceFiltersDto) {
  return useAppQuery({
    queryKey: ['ai-trace-preview', filters],
    queryFn: () => getAiTraces(filters),
    customError: true,
  });
}

export function useAiDelayedDeliveryPreview(
  filters: AiDelayedDeliveryFiltersDto
) {
  return useAppQuery({
    queryKey: ['ai-delayed-delivery-preview', filters],
    queryFn: () => getAiDelayedDeliveries(filters),
    customError: true,
  });
}
